import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './store/reducers/rootReducer';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import firebase from './config/fbconfig';

import { createFirestoreInstance, reduxFirestore, getFirestore } from 'redux-firestore';
import { ReactReduxFirebaseProvider, getFirebase } from 'react-redux-firebase';
import { useSelector  } from 'react-redux';
import { isLoaded  } from 'react-redux-firebase';
import loading from './images/loading.gif';

import 'firebase/firestore';

const rrfConfig = { 
    userProfile: 'users',
    useFirestoreForProfile: true
}

const store = createStore(rootReducer, 
    compose(
        applyMiddleware(thunk.withExtraArgument({getFirebase, getFirestore})),
        reduxFirestore(firebase)
    )
    );

const rffProps = {
    firebase,
    useFirestoreForProfile: true,
    config: rrfConfig,
    dispatch: store.dispatch,
    createFirestoreInstance,
    userProfile: 'users', 
    presence: 'presence',
    sessions: 'sessions'
}

function AuthIsLoaded({ children }) {
    const auth = useSelector(state => state.firebase.auth)
    if (!isLoaded(auth)) return( 
    <div
    style={{
        display: 'flex',
        justifyContent:'space-evenly',
        marginTop: '35vh'
    }}
    > 
        <div>
        <img 
        src={loading} 
        alt='gif' 
        style={{
            height: 90
        }}
        />
        <br></br>
        <b style={{color: 'white'}}>Loading Bound</b>    
        </div>
    </div>
    )
        return children
}

ReactDOM.render(
<Provider store={store}>
    <ReactReduxFirebaseProvider {...rffProps}>
        <AuthIsLoaded>
          <App />  
        </AuthIsLoaded>
    </ReactReduxFirebaseProvider>
</Provider>, 
document.getElementById('root'));
